// packages block
import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { images } from "../../assets/images";
// others
import { AuthLayoutProps } from "../../interfaceTypes";
import { AuthLayoutBox, AuthLayoutContainer } from "../../theme/styleComponents";

export const AuthLayout: FC<AuthLayoutProps> = ({ children, title, subTitle }) => (
  <AuthLayoutContainer>
    <Box maxWidth='543px' width='100%'>
      <Box component='img' display='block' marginX='auto' src={images.LOGO} alt='helmer legal logo' />

      <AuthLayoutBox>
        <Box>
          <Typography variant="body1" fontSize={24}>{title}</Typography>
          <Box height={24} marginBottom='30px'>
            {subTitle && <Typography variant="subtitle1" component='p'>{subTitle}</Typography>}
          </Box>

          {children}
        </Box>
      </AuthLayoutBox>
    </Box>
  </AuthLayoutContainer>
)